type ShareLinkOptions = {
  title?: string;
  text?: string;
  additionalPartsOfUrl?: string;
};

const getCleanUrl = (additionalPartsOfUrl?: string) => {
  const url = new URL(window.location.href);
  if (additionalPartsOfUrl) {
    url.pathname = `${url.pathname.replace(/\/$/, "")}/${additionalPartsOfUrl.replace(/^\//, "")}`;
  }
  url.search = "";
  url.hash = "";
  return url.toString();
};

export const copyToClipboard = (
  setCopied: React.Dispatch<React.SetStateAction<boolean>>,
  additionalPartsOfUrl?: string | undefined
) => {
  if (typeof window !== "undefined" && navigator.clipboard) {
    const url = getCleanUrl(additionalPartsOfUrl);
    navigator.clipboard
      .writeText(url)
      .then(() => {
        // console.log("Link copied to clipboard!");
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 3000);
      })
      .catch(err => {
        console.error("Failed to copy link: ", err);
      });
  }
};

export const shareOrCopyLink = async (
  setCopied: React.Dispatch<React.SetStateAction<boolean>>,
  options: ShareLinkOptions = {}
) => {
  if (typeof window === "undefined") return;

  const url = getCleanUrl(options.additionalPartsOfUrl);
  const shareData = {
    title: options.title,
    text: options.text,
    url,
  };

  if (navigator.share && (!navigator.canShare || navigator.canShare(shareData))) {
    try {
      await navigator.share(shareData);
      return;
    } catch (error: any) {
      if (error?.name === "AbortError") return;
      console.error("Failed to share link: ", error);
    }
  }

  if (navigator.clipboard) {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }
};
